<div class="flex-fill d-flex flex-column compact-form" *ngIf="!!ach">
    <div class="card">
        <div class="card-body p-2 pb-2">
            <ng-container *ngIf="this.ach.type !== 'Invoice'">
                <div *ngIf="this.ach.accountNumber && !this.ach.confirmation.declined && !this.ach.confirmation.approved" class="order-not-confirmed">
                    CONFIRMATION HAS NOT BEEN APPROVED - DO NOT PROCESS ACH PAYMENT
                </div>
                <div *ngIf="this.ach.confirmation.declined" class="order-not-confirmed">CONFIRMATION HAS BEEN DECLINED - ACH CAN BE DELETED</div>
                <div *ngIf="this.ach.confirmation.approved" class="order-confirmed">ORDER CONFIRMED {{ ach.confirmation.approved | date : 'MM/dd/yyyy - hh:mm:ss aa' }}</div>
                <div *ngIf="!this.ach.approved && !this.ach.declined" class="order-not-confirmed">ACH HAS NOT BEEN APPROVED - DO NOT PROCESS ACH PAYMENT</div>
            </ng-container>
            <ng-container *ngIf="this.ach.type === 'Invoice'">
                <div *ngIf="this.ach.declined" class="order-not-confirmed">ACH HAS BEEN DECLINED - ACH CAN BE DELETED</div>
                <div *ngIf="this.ach.approved" class="order-confirmed">ACH APPROVED {{ ach.approved | date : 'MM/dd/yyyy - hh:mm:ss aa' }}</div>
            </ng-container>

            <div class="btn-toolbar mt-1">
                <button *ngIf="hasChanges()" class="btn btn-primary" (click)="save()">Save</button>
                <button *ngIf="hasChanges()" class="btn btn-success ms-2" (click)="cancel()">Cancel</button>
                <ng-container *ngIf="!hasChanges()">
                    <button class="btn btn-sm btn-primary" (click)="close()">Close</button>
                    <button class="btn btn-sm btn-success ms-4" (click)="email()">Email ACH Form</button>
                    <button class="btn btn-sm btn-success ms-2" (click)="print()">Print ACH Form</button>
                    <button class="btn btn-sm btn-danger ms-4" (click)="manuallyApprove()" [disabled]="ach.approved">Manually Approve ACH Form</button>
                </ng-container>
            </div>
            <dx-form [formData]="ach" [colCount]="5">
                <dxi-item itemType="group" caption="Dealer" [colCount]="2">
                    <dxi-item dataField="dealer.companyName" [label]="{ text: 'Dealer' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"></dxi-item>
                    <dxi-item dataField="dealer.email" [label]="{ text: 'Sales Email' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"> </dxi-item>
                    <dxi-item dataField="dealer.aPEmail" [label]="{ text: 'AP Email' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"></dxi-item>
                    <dxi-item dataField="emailTo" [label]="{ text: 'ACH Email' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"></dxi-item>
                    <dxi-item dataField="dealer.phone1" [label]="{ text: 'Phone' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"> </dxi-item>
                    <dxi-item dataField="dealer.salesRep.name" [label]="{ text: 'Sales Rep' }" [editorOptions]="{ disabled: true }" [colSpan]="2"></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Order Information">
                    <dxi-item dataField="confirmation.order.invoiceNumber" [label]="{ text: 'Sales Order #' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item
                        dataField="confirmation.order.tax"
                        [label]="{ text: 'Tax' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item
                        dataField="confirmation.order.freight"
                        [label]="{ text: 'Freight' }"
                        [editorOptions]="{ readOnly: true, format: { type: 'currency', precision: 2 } }"
                    ></dxi-item>
                    <dxi-item
                        dataField="confirmation.order.total"
                        [label]="{ text: 'Order Total' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item dataField="amount" [label]="{ text: 'ACH Amount' }" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                    <dxi-item dataField="confirmation.paymentMethod" [label]="{ text: 'Payment Method' }" [editorOptions]="{ disabled: true }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Confirmation Info">
                    <dxi-item dataField="confirmation.confirmedBy" [label]="{ text: 'Completed By' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="confirmation.approved" [label]="{ text: 'Approved' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="confirmation.declined" [label]="{ text: 'Declined' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item
                        dataField="confirmation.cancelReason"
                        editorType="dxTextArea"
                        [label]="{ text: 'Decline Reason' }"
                        [editorOptions]="{ readOnly: true, height: 75 }"
                    ></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="ACH Info">
                    <dxi-item dataField="approvedBy" [label]="{ text: 'Completed By' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="approved" [label]="{ text: 'Approved' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="declined" [label]="{ text: 'Declined' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="cancelReason" editorType="dxTextArea" [label]="{ text: 'Decline Reason' }" [editorOptions]="{ readOnly: true, height: 75 }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Attachments">
                    <dxi-item>
                        <div *dxTemplate>
                            <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="achAttachments">
                                <li *ngFor="let attachment of achAttachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-file-uploader
                                name="fileUpload"
                                selectButtonText="Select File(s)"
                                class="attachments"
                                accept="*"
                                uploadMode="instantly"
                                [showFileList]="false"
                                [multiple]="true"
                                [uploadUrl]="uploadUrl"
                                [uploadHeaders]="uploadHeader"
                                (onUploadStarted)="uploadStarted($event)"
                                (onUploadError)="uploadError($event)"
                                (onUploaded)="uploaded($event)"
                            >
                            </dx-file-uploader>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Notes' }" [editorOptions]="{ height: 125 }"></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Bank Information" [colSpan]="1">
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-form [formData]="bankInfo" [readOnly]="true">
                                <dxi-item dataField="accountType"> </dxi-item>
                                <dxi-item dataField="accountName"> </dxi-item>
                                <dxi-item dataField="bankName"> </dxi-item>
                                <dxi-item dataField="accountNumber"> </dxi-item>
                                <dxi-item dataField="routingNumber"> </dxi-item>
                            </dx-form>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="approvedBy" [editorOptions]="{ readOnly: true }"> </dxi-item>
                    <dxi-item dataField="approved" [editorOptions]="{ readOnly: true }"> </dxi-item>
                    <dxi-item *ngIf="canSeeEncodeButton">
                        <div *dxTemplate>
                            <button class="mt-1 btn btn-sm btn-warning" (click)="toggleIsBankInfoEncoded()">
                                {{ isBankInfoEncoded ? 'Decode Bank Information' : 'Encode Bank Information' }}
                            </button>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item [colSpan]="3">
                    <div class="me-5" *dxTemplate>
                        <div class="d-flex">
                            <div class="column ms-2 me-3"><span class="color-legend with-border ach-not-approved"></span> - ACH Not Approved</div>
                            <div class="column ms-2 me-3"><span class="color-legend with-border ach-transaction-initiated"></span> - ACH Initiated</div>
                            <div class="column ms-2 me-3"><span class="color-legend with-border ach-transaction-complete"></span> - ACH Completed</div>
                        </div>
                        <dx-data-grid
                            #dataGrid
                            class="m-2 grid-fill flex-fill"
                            keyExpr="id"
                            height="400"
                            [dataSource]="achTransactions"
                            [columnAutoWidth]="false"
                            [showBorders]="true"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                            (onRowDblClick)="rowDoubleClick($event)"
                            (onOptionChanged)="onOptionChanged($event)"
                            (onContentReady)="onContentReady($event)"
                            (onRowPrepared)="rowPrepare($event)"
                            (onExporting)="onExporting($event)"
                        >
                            <dxi-column dataField="id" width="75" [sortIndex]="0" sortOrder="desc"></dxi-column>
                            <dxi-column dataField="ach.confirmation.paymentMethod" caption="ACH Type" width="100"></dxi-column>
                            <dxi-column dataField="invoice.invoiceNumber" caption="Invoice #" width="100" cellTemplate="invoiceLinkTemplate"></dxi-column>
                            <dxi-column dataField="amount" caption="ACH Amount" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                            <dxi-column dataField="bankConfirmationNumber" width="200" caption="Bank Confirmation #"></dxi-column>
                            <dxi-column dataField="transferInitiated" width="100" caption="Initiated"></dxi-column>
                            <dxi-column dataField="transferInitiatedBy" caption="Initiated By" width="100"></dxi-column>
                            <dxi-column dataField="depositAcknowledged" caption="Deposit Ack." width="100"></dxi-column>
                            <dxi-column dataField="depositAcknowledgedBy" caption="Ack. By" width="100"></dxi-column>
                            <dxi-column dataField="created" caption="Created" width="100"></dxi-column>
                            <dxi-column dataField="createdBy" caption="Created By" width="100"></dxi-column>
                            <dxi-column dataField="notes" width="100"></dxi-column>
                            <dxi-column width="20"></dxi-column>

                            <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                                <a [routerLink]="[]" (click)="openInvoice(cell.data)">{{ cell.value }}</a>
                            </div>

                            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ach-transaction-detail-grid"></dxo-state-storing>
                            <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>

                            <dxo-summary>
                                <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                            </dxo-summary>

                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <button class="btn btn-sm btn-primary" (click)="addTransaction()" [hidden]="!ach.approved || ach.type === 'Invoice'">Add</button>
                                <button
                                    class="btn btn-sm btn-success ms-2"
                                    (click)="dataGrid.instance.getSelectedRowsData().length > 1 ? bulkEditTransactions(dataGrid.instance.getSelectedRowsData()) : addTransaction(dataGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !ach.approved"
                                >
                                    {{dataGrid.instance.getSelectedRowsData().length > 1 ? 'Bulk ' : ''}}Edit
                                </button>
                                <button
                                    class="btn btn-sm btn-danger ms-2"
                                    (click)="deleteTransaction(dataGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || !ach.approved"
                                    [hidden]="!ach.approved || ach.type === 'Invoice'"
                                >
                                    Delete
                                </button>
                                <button
                                    class="btn btn-sm btn-success ms-2"
                                    (click)="markAsDeposited()"
                                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || !ach.approved"
                                >
                                    Mark as Deposited
                                </button>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                <span *ngIf="aches" class="me-2">
                                    <strong>
                                        {{ dataGrid.instance.totalCount() + ' items' }}
                                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                                    </strong>
                                </span>
                            </div>
                        </dx-data-grid>
                    </div>
                </dxi-item>

                <dxi-item itemType="group" caption="Notes" [colSpan]="1">
                    <div class="me-5" *dxTemplate>
                        <dx-data-grid
                            #notesGrid
                            class="m-2 grid-fill flex-fill"
                            keyExpr="id"
                            height="400"
                            [dataSource]="notes"
                            [columnAutoWidth]="false"
                            [showBorders]="true"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                        >
                            <dxi-column dataField="created" width="70"></dxi-column>
                            <dxi-column dataField="createdBy" width="70"></dxi-column>
                            <dxi-column dataField="notes"></dxi-column>

                            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>

                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <button class="btn btn-sm btn-primary" (click)="addNote()">Add</button>
                                <button
                                    class="btn btn-sm btn-success ms-2"
                                    (click)="editNote(notesGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="notesGrid.instance.getSelectedRowsData().length !== 1"
                                >
                                    Edit
                                </button>
                                <button
                                    class="btn btn-sm btn-danger ms-2"
                                    (click)="deleteNote(notesGrid.instance.getSelectedRowsData()[0])"
                                    [disabled]="notesGrid.instance.getSelectedRowsData().length !== 1"
                                >
                                    Delete
                                </button>
                            </div>
                            <div *dxTemplate="let data of 'toolbarText'">
                                <span *ngIf="aches" class="me-2">
                                    <strong>
                                        {{ notesGrid.instance.totalCount() + ' items' }}
                                        {{ notesGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                                    </strong>
                                </span>
                            </div>
                        </dx-data-grid>
                    </div>
                </dxi-item>

                <!-- <dxi-item itemType="group" caption="Notes" [colSpan]="2">
                    <dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Notes' }" [editorOptions]="{ height: 125 }"></dxi-item>
                </dxi-item> -->
            </dx-form>
        </div>
    </div>
</div>
